import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import VerificationCodeInput from '@/components/VerificationCodeInput'
import { useSendCode } from '@/hooks/useSendCode'
import { APIWeb } from '@/api/index'

export default React.memo(function VerAccountCode() {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { state } = useLocation()
    console.log('verifyAccount', state)
    const { sendCode, sendCodeLoading } = useSendCode()
    const [submitLoading, setSubmitLoading] = useState(false)
    // 从 URL 查询参数读取验证码数据

    const handleResendCode = useCallback(async () => {
        await sendCode({
            account: state?.account || '',
            scene: 'password_reset',
        })
    }, [sendCode, state?.account])

    // 提交验证码验证得到verify_key跳转设置新账户界面

    const handleSubmit = async (code: string) => {
        setSubmitLoading(true)
        try {
            const data = await APIWeb.verifyForgotPasswordCode({
                account: state?.account || 'google',
                scene: 'password_reset',
                code,
            })
            if (data) {
                navigate('/forgot-password/reset-password', {
                    state: {
                        account: state?.account || '',
                        verify_key: data?.verify_key || '',
                        ...state,
                    },
                })

            }
        } catch (error) {
            console.log('error', error)
        } finally {
            setSubmitLoading(false)
        }
    }
    return (
        <PageLayout>
            <Header leftChildren={<Back />} />
            {/* Content */}
            <div className="px-6 py-6">
                <VerificationCodeInput
                    account={state?.account}
                    resendLoading={sendCodeLoading}
                    submitLoading={submitLoading}
                    onResendCode={handleResendCode}
                    onSubmit={handleSubmit}
                    submitButtonText={t('确认')}
                />
            </div>
        </PageLayout>
    )
})
